import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { downloadCvPdf, downloadCvDocx } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Printer, Loader2, FolderArchive, Download, FileType } from "lucide-react";
import { toast } from "sonner";

export default function Dokument() {
  const [cvs, setCvs] = useState(null);
  const [dl, setDl] = useState(null); // `${id}-pdf` | `${id}-docx`
  useEffect(() => { api.get("/cvs").then((r) => setCvs(r.data)); }, []);

  const download = async (cv, type) => {
    const key = `${cv.id}-${type}`;
    setDl(key);
    const fname = `HAMN_CV_${(cv.company || "CV")}-${(cv.title || "")}`.replace(/\s+/g, "_");
    try {
      if (type === "pdf") await downloadCvPdf(cv.id, fname + ".pdf");
      else await downloadCvDocx(cv.id, fname + ".docx");
    } catch { toast.error(`Kunde inte ladda ner ${type.toUpperCase()}`); }
    finally { setDl(null); }
  };

  if (cvs === null) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-primary" /></div>;
  const finals = cvs.filter((c) => c.status === "final");

  return (
    <div>
      <PageHeader title="Mina dokument" description="Här samlas dina godkända CV:n som färdiga dokument. Öppna A4-vyn för att skriva ut eller spara som PDF." />
      {finals.length === 0 ? (
        <Card className="rounded-2xl border-dashed border-2 border-border p-12 text-center">
          <FolderArchive className="h-10 w-10 mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground">Inga godkända dokument ännu. Godkänn ett CV i redigeringsvyn för att lägga till det här.</p>
          <Link to="/app/cv"><Button variant="outline" className="rounded-full mt-4">Till mina CV:n</Button></Link>
        </Card>
      ) : (
        <div className="grid gap-4">
          {finals.map((cv) => (
            <Card key={cv.id} className="rounded-2xl border-border p-5 flex items-center justify-between gap-4">
              <div className="flex items-center gap-4 min-w-0">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary shrink-0"><FileText className="h-5 w-5" /></div>
                <div className="min-w-0">
                  <div className="font-head font-semibold truncate">{cv.company} – {cv.title}</div>
                  <div className="text-sm text-muted-foreground">Godkänd · {new Date(cv.updated_at || cv.created_at).toLocaleDateString("sv-SE")}</div>
                </div>
              </div>
              <div className="flex gap-2 shrink-0">
                <Link to={`/cv-print/${cv.id}`} target="_blank"><Button variant="outline" className="rounded-full"><Printer className="h-4 w-4 mr-1.5" /> A4</Button></Link>
                <Button className="rounded-full" data-testid={`doc-pdf-${cv.id}`} disabled={dl !== null} onClick={() => download(cv, "pdf")}>{dl === `${cv.id}-pdf` ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Download className="h-4 w-4 mr-1.5" />} PDF</Button>
                <Button variant="outline" className="rounded-full" data-testid={`doc-docx-${cv.id}`} disabled={dl !== null} onClick={() => download(cv, "docx")}>{dl === `${cv.id}-docx` ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileType className="h-4 w-4 mr-1.5" />} Word</Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
